import React, {Component} from 'react';
import bus from './bus';
import Ajax from './ajax';

class Remain extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
    }

    submit(event) {
        event.preventDefault();
        if (this.name.value.length <= 0) {
            alert('请输入项目名称');
        } else {
            Ajax.post('remain/send', {name: this.name.value}, function (response) {
                if (response.result) {
                    bus.emit('result', response);
                }
            });
        }
    }

    render() {
        return (
            <form onSubmit={this.submit}>
                <div className="weui-cells weui-cells_form">
                    <div className="weui-cell">
                        <div className="weui-cell__hd"><label className="weui-label">项目名称</label></div>
                        <div className="weui-cell__bd">
                            <input ref={(name) => this.name = name} name="name" className="weui-input" type="text" placeholder="请输入项目名称"/>
                        </div>
                    </div>
                    <div className="weui-btn-area">
                        <input className="weui-btn weui-btn_primary" type="submit" value="查询"/>
                    </div>
                </div>
            </form>
        );
    }
}

export default Remain;



// WEBPACK FOOTER //
// ./src/remain.js